// src/App.tsx
// Updated with drivers, passengers, and onboarding routes

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/common/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import UserDetailPage from './pages/UserDetailPage';
import DriversPage from './pages/DriversPage';
import PassengersPage from './pages/PassengersPage';
import OnboardingListPage from './pages/OnboardingListPage';
import OnboardingDetailPage from './pages/OnboardingDetailPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users/:userId"
          element={
            <ProtectedRoute>
              <UserDetailPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/drivers"
          element={
            <ProtectedRoute>
              <DriversPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/passengers"
          element={
            <ProtectedRoute>
              <PassengersPage />
            </ProtectedRoute>
          }
        />

        {/* Onboarding Routes - NEW! */}
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <OnboardingListPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/onboarding/:userId"
          element={
            <ProtectedRoute>
              <OnboardingDetailPage />
            </ProtectedRoute>
          }
        />

        {/* Default Routes */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;